<div class="footer fx-row">
  <div class="fx-row fx-align-start-center fx-flex-auto" vexContainer>
    <a class="action fx-flex-none"
       color="primary"
       href="//1.envato.market/0vkRO"
       id="get-vex"
       mat-raised-button>
      <ic-icon [icon]="icShoppingBasket" class="ltr:mr-2 rtl:ml-2" inline="true" size="18px"></ic-icon>
 
    </a>
    <div class="ltr:ml-4 rtl:mr-4 fx-hide--lt-md">
      Designflow
    </div>
  </div>
</div>
